import Request from "./request";
import Params from "./params";

let controllerName = (() => {
  return window.location.pathname.split("/")[1];
})();
//localStorage.clear();
let controllerID = null;

const baseURL = Params.apiOrder;
const verifyServer = Params.verificationServer;
const tokenAcces = Params.tokenAccess;
const menuUrl = Params.apiMenu;
//const verifyServer = `http://localhost:8081`;

let cachedTag = localStorage.getItem(controllerName);
let tag = cachedTag ? JSON.parse(cachedTag).tag : null;

const API = {
  // this function will check everytime an api is called to set the controllerID
  // because this is an object initiated at different places of the application
  // not really good but too late to change.
  getDomainUrl: () => {
    // Ensure controllerID is set before using it
    API.checkControllerId();
    
    // Check if controllerID is valid
    if (!controllerID || controllerID === 'undefined' || controllerID === 'null') {
      console.error('❌ ControllerID is undefined or invalid:', controllerID);
      console.log('🔍 Available localStorage keys:', Object.keys(localStorage));
      console.log('🔍 Looking for controller name:', controllerName);
      return baseURL + "/online";
    }
    
    let apiServer = localStorage.getItem(`${controllerID}_apiserver`);
    console.log(`🔍 Checking API server for controller ${controllerID}:`, apiServer);
    
    if (
      apiServer !== null &&
      apiServer !== "" &&
      apiServer !== "undefined" &&
      apiServer !== undefined
    ) {
      if (apiServer.charAt(apiServer.length - 1) === "/") {
        apiServer = apiServer.slice(0, -1);
      }
      console.log('✅ Using custom API server:', apiServer);
    } else {
      apiServer = baseURL + "/online";
      console.log('✅ Using default API server:', apiServer);
    }

    return apiServer;
  },
  checkControllerId: () => {
    if (controllerID === null || controllerID === undefined) {
      console.log('🔍 ControllerID is null, fetching from localStorage...');
      console.log('🔍 Controller name:', controllerName);
      
      controllerID = localStorage.getItem(`${controllerName}_id`);
      console.log('🔍 Retrieved controllerID from localStorage:', controllerID);

      cachedTag = localStorage.getItem(controllerName);
      tag = cachedTag ? JSON.parse(cachedTag).tag : null;
      
      // Additional validation
      if (!controllerID || controllerID === 'undefined' || controllerID === 'null') {
        console.error('❌ ControllerID is still invalid after localStorage fetch:', controllerID);
        console.log('🔍 Available localStorage keys:', Object.keys(localStorage));
        console.log('🔍 Looking for key:', `${controllerName}_id`);
      } else {
        console.log('✅ ControllerID successfully retrieved:', controllerID);
      }
    }
  },
  getMenu: (isCached) => {
    const endpoint = `${menuUrl}/menu/2api/${controllerName}/true/${isCached}/2`;
    //const endpoint = `https://www.foodzaps.com/v10_mobile_staging/menu/2api/${controllerName}/true/${isCached}/2`;
    //const endpoint = `https://onlineordering-env-29zy38zqgq.foodzaps.com/menu/2api/${controllerName}/true/${isCached}/2`;
    //const endpoint = `http://localhost:8081/menu/2api/${controllerName}/true/${isCached}/2`;
    //const endpoint = `https://inruo.serveo.net/menu`;
    // return Request.get(endpoint);
    return Request.getGZipApi(endpoint);
  },
  // DEPRECATED: prepareOrderRequest is no longer needed
  // We now use createOrder for both main checkout and payment processing
  /*
  prepareOrderRequest: (payload) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl +
      `/createOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&type=web&returnHTML=0&tag=${tag}`;
    request += `${payload}`;
    return Request.get(request);
  },
  */

  // Alternative method for payment processing that doesn't create actual order
  // This should return orderKey without creating the order
  prepareOrderForPayment: (payload) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl +
      `/prepareOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&type=web&returnHTML=0&tag=${tag}`;
    request += `${payload}`;
    return Request.get(request);
  },

  // Restored prepareOrderRequest for payment processing only
  // This uses /createOrder/ endpoint but only for payment processing
  prepareOrderRequest: (payload) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl +
      `/createOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&type=web&returnHTML=0&tag=${tag}`;
    request += `${payload}`;
    return Request.get(request);
  },


  
  // DEPRECATED: prepareOrderRequestPost is no longer needed
  // We now go directly from cart to createOrder
  /*
  // Alternative method using POST to avoid long URLs
  prepareOrderRequestPost: (payload) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let requestUrl = serverUrl + `/createOrder/${controllerID}`;
    
    // Keep base parameters in URL
    requestUrl += `?accessToken=${tokenAcces}&type=web&returnHTML=0&tag=${tag}`;
    
    // Send payload data in POST body as URL-encoded string
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    
    // Remove leading '&' if present in payload
    const bodyData = payload.startsWith('&') ? payload.substring(1) : payload;
    
    return Request.post(requestUrl, bodyData, headers);
  },
  */
  calculateTaxs: (orderId) => {
    API.checkControllerId();
    // check if order is successful
    // if no success in json response = pending order
    //const request = `${baseURL}/v13_mobile/online/getOrderStatus/${controllerID}/${orderId}?accessToken=foodzaps`;
    let serverUrl = API.getDomainUrl();
    const request =
      serverUrl +
      `/getOrderStatus/${controllerID}/${orderId}?accessToken=` +
      tokenAcces;
    return Request.get(request);
  },
  // Main order creation method - now called directly from cart
  // This replaces the previous 2-step process (prepareOrderRequest + createOrder)
  createOrder: (payload, verificationCode) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    
    // Use /createOrder/ endpoint with accessToken
    let request =
      serverUrl + 
      `/createOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&type=web&returnHTML=0&tag=${tag}`;

    if (verificationCode) request += `&verify=${verificationCode}`;

    request += `${payload}`;
    console.log('🌐 Creating order with URL:', request);
    console.log('📦 Payload:', payload);
    return Request.get(request);
  },

  // POST version of createOrder to avoid long URLs
  createOrderPost: (payload, verificationCode) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let requestUrl = serverUrl + `/add/${controllerID}`;

    if (
      payload.indexOf("payment=") !== -1 &&
      payload.indexOf('"method":"cash"') === -1
    ) {
      let serverUrl1 = API.getPaymentServerUrl();
      requestUrl = `${serverUrl1}verify/add/${controllerID}`;
      
      // Add serverUrl to query params for payment verification
      requestUrl += `?returnHTML=0&type=web&tag=${tag}&serverUrl=${encodeURIComponent(serverUrl)}`;
    } else {
      requestUrl += `?returnHTML=0&type=web&tag=${tag}`;
    }
    
    if (verificationCode) requestUrl += `&verify=${verificationCode}`;

    // Send payload in POST body
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    
    const bodyData = payload.startsWith('&') ? payload.substring(1) : payload;
    
    return Request.post(requestUrl, bodyData, headers);
  },

  // Smart method that chooses GET or POST based on payload length
  createOrderOptimized: (payload, verificationCode) => {
    const maxGetLength = 2000;
    
    if (payload.length > maxGetLength) {
      console.log(`Payload too long (${payload.length} chars), using POST for createOrder`);
      return API.createOrderPost(payload, verificationCode);
    } else {
      console.log(`Payload length OK (${payload.length} chars), using GET for createOrder`);
      return API.createOrder(payload, verificationCode);
    }
  },

  // Fire-and-forget order creation - don't wait for response
  createOrderAsync: (payload, verificationCode) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    
    // Use /createOrder/ endpoint with accessToken
    let request =
      serverUrl + 
      `/createOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&type=web&returnHTML=0&tag=${tag}`;

    if (verificationCode) request += `&verify=${verificationCode}`;

    request += `${payload}`;
    
    // Send request without waiting for response
    console.log('🚀 Sending order request (fire-and-forget):', request);
    
    // Use XMLHttpRequest for fire-and-forget
    const xhr = new XMLHttpRequest();
    xhr.open('GET', request, true);
    xhr.timeout = 5000; // 5 second timeout
    
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          console.log('✅ Order request sent successfully (async)');
        } else {
          console.log('⚠️ Order request sent but got status:', xhr.status);
        }
      }
    };
    
    xhr.onerror = function() {
      console.log('❌ Order request failed to send (async)');
    };
    
    xhr.ontimeout = function() {
      console.log('⏰ Order request timeout (async)');
    };
    
    xhr.send();
    
    // Return immediately with a promise that resolves quickly
    return Promise.resolve({
      status: 'sent',
      message: 'Order request sent asynchronously',
      timestamp: new Date().toISOString()
    });
  },
  checkOrder: (payload, verificationCode) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl +
      `/verifyOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&returnHTML=0&tag=${tag}`;
    if (verificationCode) request += `&verify=${verificationCode}`;
    request += `${payload}`;
    return Request.get(request);
  },
  checkOrderStatus: (url) => {
    return Request.get(url);
  },
  changeTableCallApi: (payload) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    let request =
      serverUrl +
      `/transferOrder/${controllerID}?accessToken=` +
      tokenAcces +
      `&returnHTML=0&tag=${tag}`;
    request += `${payload}`;
    return Request.get(request);
  },
  requestBillNewApi: (msg) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    const requestUrl = serverUrl + `/bill/${controllerID}`;
    return Request.post(
      requestUrl,
      `accessToken=` +
        tokenAcces +
        `&returnHTML=0&tag=${tag}&order=${encodeURIComponent(msg)}`
    );
  },
  addOrderByPost: (suburl, payload) => {
    API.checkControllerId();
    let serverUrl = API.getPaymentServerUrl();
    const requestUrl = serverUrl + suburl;
    // const requestUrl = `http://localhost:8081/`+suburl;
    //// console.log(requestUrl);
    return Request.post(
      requestUrl,
      `accessToken=` + tokenAcces + `&returnHTML=0&tag=${tag}&` + payload
    );
  },
  getOrder: (orderId) => {
    API.checkControllerId();
    // check if order is successful
    // if no success in json response = pending order
    let serverUrl = API.getDomainUrl();
    const request = serverUrl + `/get/${controllerID}/${orderId}?act=test`;

    return Request.get(request);
  },
  
  // REMOVED: getRecentOrders, getOrderByUuid, getRealUUID methods
  // These endpoints don't exist on server and caused 404 errors
  
  // Retry with exponential backoff for network errors
  // Delays: 1s, 2s, 4s, 8s, 16s
  // Max attempts: 5
  // Total max time: 31s
  retryWithExponentialBackoff: (apiCall, maxRetries = 5, initialDelay = 1000) => {
    return new Promise((resolve, reject) => {
      let retryCount = 0;
      
      const attempt = () => {
        apiCall()
          .then(resolve)
          .catch((error) => {
            retryCount++;
            
            if (retryCount >= maxRetries) {
              console.log(`❌ Max retries (${maxRetries}) reached, giving up`);
              reject({
                error: error,
                message: 'Max retries reached',
                retryCount: retryCount
              });
              return;
            }
            
            // Calculate exponential backoff delay: 1s, 2s, 4s, 8s, 16s
            const delay = initialDelay * Math.pow(2, retryCount - 1);
            const cappedDelay = Math.min(delay, 16000); // Cap at 16s
            
            console.log(`⚠️ Request failed (attempt ${retryCount}/${maxRetries}), retrying in ${cappedDelay}ms...`);
            console.log('Error:', error);
            
            setTimeout(attempt, cappedDelay);
          });
      };
      
      // Start first attempt
      attempt();
    });
  },

  // Poll order status with adaptive intervals
  // Optimized polling: fast initial checks, then slower intervals
  // First 5 polls: 500ms (2.5s total)
  // Next 10 polls: 1000ms (10s total)
  // Remaining polls: 2000ms (up to 20s)
  // Max total time: ~32.5s (50% faster than before)
  pollOrderStatus: (orderId, maxAttempts = 25, options = {}) => {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const startTime = Date.now();
      
      // Adaptive polling intervals based on attempt number
      const getPollingDelay = (attemptNum) => {
        if (attemptNum <= 5) return 500;   // Fast initial checks
        if (attemptNum <= 15) return 1000; // Standard checks
        return 2000;                        // Slower checks
      };
      
      const poll = () => {
        attempts++;
        const currentDelay = getPollingDelay(attempts);
        const elapsedTime = ((Date.now() - startTime) / 1000).toFixed(1);
        
        console.log(`🔄 [Adaptive Poll] Attempt ${attempts}/${maxAttempts} (${elapsedTime}s elapsed, next delay: ${currentDelay}ms):`, orderId);
        
        API.getOrder(orderId)
          .then((res) => {
            console.log('📋 Poll response:', res);
            
            if (res && res.success !== undefined) {
              // Order found with status
              const totalTime = ((Date.now() - startTime) / 1000).toFixed(1);
              console.log(`✅ Order confirmed in ${totalTime}s after ${attempts} attempts`);
              
              resolve({
                success: res.success,
                orderId: orderId,
                orderNo: res.orderNo,
                msg: res.msg,
                attempts: attempts,
                totalTime: totalTime,
                final: true
              });
            } else if (res && res.indexOf && res.indexOf("PHP Error") !== -1) {
              // PHP Error - order might not exist yet
              console.log('⚠️ PHP Error in poll - order might not exist yet');
              if (attempts < maxAttempts) {
                const nextDelay = getPollingDelay(attempts + 1);
                setTimeout(poll, nextDelay);
              } else {
                const totalTime = ((Date.now() - startTime) / 1000).toFixed(1);
                console.log(`❌ Max polling attempts reached after ${totalTime}s`);
                resolve({
                  success: false,
                  orderId: orderId,
                  attempts: attempts,
                  totalTime: totalTime,
                  final: true,
                  error: 'Max polling attempts reached'
                });
              }
            } else {
              // Empty response or other error - order might not exist yet
              console.log('📭 Empty/unknown response - order might not exist yet');
              if (attempts < maxAttempts) {
                const nextDelay = getPollingDelay(attempts + 1);
                setTimeout(poll, nextDelay);
              } else {
                const totalTime = ((Date.now() - startTime) / 1000).toFixed(1);
                console.log(`❌ Max polling attempts reached after ${totalTime}s`);
                resolve({
                  success: false,
                  orderId: orderId,
                  attempts: attempts,
                  totalTime: totalTime,
                  final: true,
                  error: 'Max polling attempts reached'
                });
              }
            }
          })
          .catch((err) => {
            console.log('❌ Poll error:', err);
            if (attempts < maxAttempts) {
              // On error, wait a bit longer before retrying
              const nextDelay = Math.max(getPollingDelay(attempts + 1), 1000);
              setTimeout(poll, nextDelay);
            } else {
              const totalTime = ((Date.now() - startTime) / 1000).toFixed(1);
              console.log(`❌ Max polling attempts reached after ${totalTime}s due to errors`);
              resolve({
                success: false,
                orderId: orderId,
                attempts: attempts,
                totalTime: totalTime,
                final: true,
                error: 'Max polling attempts reached'
              });
            }
          });
      };
      
      // Start first poll with initial delay
      const initialDelay = options.initialDelay || 500;
      setTimeout(poll, initialDelay);
    });
  },
  
  callForWaiter: (msg) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    const request =
      serverUrl +
      `/call/${controllerID}?action=waiter&tag=${tag}&msg=${encodeURIComponent(
        msg
      )}`;

    return Request.get(request);
  },
  callForBill: (msg) => {
    API.checkControllerId();
    let serverUrl = API.getDomainUrl();
    const request =
      serverUrl +
      `/call/${controllerID}?action=cashier&tag=${tag}&msg=${encodeURIComponent(
        msg
      )}`;

    return Request.get(request);
  },
  sendEmail: (msg) => {
    const request = `${verifyServer}send-email?msg=${encodeURIComponent(msg)}`;
    return Request.get(request);
  },
  getPaymentServerUrl: () => {
    let verifyServerRest = localStorage.getItem(
      `${controllerName}_verifyserver`
    );
    let serverUrl1 = verifyServer;
    if (verifyServerRest) {
      serverUrl1 = verifyServerRest;
    }
    return serverUrl1;
  },
  checkShippingCharge: (url, params) => {
    return Request.postJson(url, params);
  },
  callPostJson: (suburl, params) => {
    API.checkControllerId();
    let serverUrl = API.getPaymentServerUrl();
    const requestUrl = serverUrl + suburl;
    return Request.postJson(requestUrl, params);
  },
  updateSpotOrder: (customOrderId, status, label) => {
    API.checkControllerId();
    let payload = {
      controllerId: controllerID,
      customOrderId: customOrderId,
      status: status,
      message: label + " - Pay at counter after meal",
    };
    if (localStorage.getItem("spotMethod") === "spot") {
      let resp = API.callPostJson("update-spot-order", payload);
// console.log(resp);
    }
  },
  createSpotMessage: (message) => {
    API.checkControllerId();
    let payload = {
      controllerId: controllerID,
      message: {
        ...message,
      },
    };
    if (localStorage.getItem("spotMethod") === "spot") {
      let resp = API.callPostJson("create-spot-message", payload);
// console.log(resp);
    }
  },
  getPingStaus: (pingurl) => {
    // Validate pingurl before using it
    if (!pingurl || pingurl === 'undefined' || pingurl === 'null') {
      console.error('❌ Ping URL is undefined or invalid:', pingurl);
      console.log('🔍 Using default scan URL from params:', Params.scanUrl);
      pingurl = Params.scanUrl || 'https://gcorder.foodzaps.com/online/getPing';
    }
    
    const fullUrl = pingurl + "?accessToken=foodzaps&type=QR";
    console.log('🔍 Making ping request to:', fullUrl);
    return Request.get(fullUrl);
  },
  getPingYeahpayStatus: (controller, refId) => {
    return Request.postJson(
      verifyServer + `yeahpay/order?controller=${controller}&sandbox=false`,
      {
        orderId: refId,
      }
    );
  },
  callbackPingYeahpayStatus: (paymentPayload) => {
    return Request.postJson(verifyServer + "yeahpay/callback", paymentPayload);
  },
  requestAddressBasedPostal: (url, params) => {
    return Request.post(url, params);
  },
  /*,
        getIP:() => {    
         // const request = `${baseURL}/get-ip`;
          const request = 'https://api.ipify.org/?format=json';
          return Request.get(request);
        }*/
};

export default API;
